module.exports = __webpack_public_path__ + "assets/img/pos.10253215.svg";